//NPM LIBRARIES
import React, { Fragment } from 'react';
import { AUcallout } from '@gov.au/callout';
import AUpageAlert from '@gov.au/page-alerts';
import AUDirectionLink from '@gov.au/direction-links';
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import moment from 'moment';
import queryString from 'query-string';
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { AUformGroup } from '@gov.au/form';

//ACTIONS AND SELECTORS
import { getFormDataSelector, getFormPropertiesSelector } from '../FormStore/Selectors/FormDataSelectors';
import { addPageAlert } from '../PortalStore/Actions/PageAlertActions';
import { getDroneRateCards, FETCH_RATECARDS_SUCCESS } from '../PortalStore/Actions/RateCardsActions';
import { getDroneCrmReferenceData, FETCH_CRMREFERENCEDATA_SUCCESS } from '../FormStore/Actions/CRMReferenceDataActions';
import { getDronesIndividual, FETCH_DRONESINDIVIDUAL_SUCCESS } from '../PortalStore/Actions/DronesIndividualActions';
import { getExpirySelector, getUrlSelector, getSnippetSelector, getFeatureSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { dronesRenewalSubmission } from '../FormStore/Actions/FormServiceActions/DronesRenew/DronesRenewSubmissionAction';
import { SUBMISSION_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SubmissionAction';
import { validateHmac, VALIDATE_HMAC_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/ValidateHmacAction';
import { addStepDataPromise } from '../FormStore/Actions/FormDataActions/GenericFormDataAction';
import { addDraftFormDataPromise } from '../FormStore/Actions/FormDataActions/GenericFormDataAction';
import { saveDraft, SAVE_DRAFT_SUCCESS } from '../FormStore/Actions/FormServiceActions/GenericFormServiceActions/SaveDraftAction';

//COMPONENTS AND UTILITIES
import Application from '../components/CASAForm/Application';
import Question from '../components/CASAForm/Question';
import SortedTable from '../components/Portal/SortedTable';
import Step from '../components/CASAForm/Step';
import CasaModal from '../components/CASA/CasaModal';
import CASASpinner from '../components/Portal/CASASpinner';
import Container from '../components/CASA/Container';
import SuccessScreen from '../pages/SuccessScreen';
import { getParamValue } from '../components/Portal/Utilities';

export const DronesRenewInd = () => {
    const [pageLoading, setPageLoading] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [applicationSubmitting, setApplicationSubmitting] = useState(false);
    const [applicationSaving, setApplicationSaving] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [modalActive, setModalActive] = useState(false);
    const [removeDroneId, setRemoveDroneId] = useState('');
    const [removeDroneName, setRemoveDroneName] = useState('');
    const [removeDroneSerial, setRemoveDroneSerial] = useState('');
    const [droneRemoved, setDroneRemoved] = useState(false);
    const [drones, setDrones] = useState([]);
    const [returnParameters] = useState(queryString.parse(window.location.search))
    const [paymentSucceeded, setPaymentSucceeded] = useState(false);
    const [tableError, setTableError] = useState('');

    let dispatch = useDispatch();
    let history = useHistory();

    let user = useSelector(state => state.userdetails);
    let B2CSettings = useSelector(state => state.B2CSettings);
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let dronesIndividual = useSelector(state => state.dronesIndividual);
    let ratecards = useSelector(state => state.ratecards.items)
    let crmReferenceData = useSelector(state => state.crmReferenceData.referenceData)

    let formProperties = useSelector(state => getFormPropertiesSelector(state.formStore));
    let formData = useSelector(state => getFormDataSelector(state.formStore, 'genericFormData'));

    let daysRPAexpiring = useSelector(state => getExpirySelector(state, "Portal - RPA registration expiry warning period"));
    let daysRPAexpired = useSelector(state => getExpirySelector(state, "Portal - RPA registration expired warning period"));

    const snippet = useSelector(state => getSnippetSelector(state, 'CASA - Drone registration renewal successful'));

    let featureRecDrone = useSelector(state => getFeatureSelector(state, "Portal - Feature Availability - Recreational Drone"));

    const weightList = crmReferenceData?.DRONE_WEIGHT_CLASS ?? []
    const maxWeightClassCode = weightList[weightList.length - 1]?.casa_code ?? ''
    const maxWeightClassValue = weightList[weightList.length - 1]?.casa_name ?? ''

    const selectedWeightClassCode = getParamValue('selectedWeightClassCode') ?? ''
    const selectedWeightClassValue = getParamValue('selectedWeightClassValue') ?? ''
    const droneRegId = getParamValue('droneRegId') ?? '';
    const renewAll = getParamValue('renewAll') ?? false;

    let from = "ind";

    let crumbs = [];
    let crumb = {};

    let jparams = {
        from: from
    }

    crumb = {
        link: '/forms/dashind',
        text: 'myCASA'
    };
    crumbs.push(crumb);
    crumb = {
        link: '/forms/dashind?params=' + encodeURIComponent(btoa(JSON.stringify(jparams))),
        text: 'Manage registered <abbr title="Remotely piloted aircraft">drone</abbr>s'
    }
    crumbs.push(crumb);
    crumb = {
        text: 'Renew <abbr title="Remotely piloted aircraft">drone</abbr> registration',
    }
    crumbs.push(crumb);

    useEffect(() => {
        if (getParamValue('paymentError')) {
            dispatch(addPageAlert({
                level: 'error',
                title: 'There was a problem with your card',
                message: 'Please check your card details or use a different card. Your application has been saved and can be submitted again from your profile screen.'
            }));
            loadRefData();
            return;
        }

        if (returnParameters.summaryCode === "0") {
            validatePayment();
        } else {
            if (returnParameters.customRef) {
                //payment cancelled
                let params = {
                    'recordid': returnParameters.customRef,
                    'paymentError': returnParameters.responseDescription
                };
                window.location.href = '/forms/dronesrenewind?params=' + encodeURIComponent(btoa(JSON.stringify(params)));
            }
            else {
                loadRefData();
            }
        }
    }, []);

    const loadRefData = () => {

        const webappurlForms = B2CSettings.items.webappurlFormsApi;
        const accessToken = B2CSettings.items.accesstokenPortal;
        const droneTypes = featureRecDrone ? ['recreational', 'commercial'] : ['commercial'];

        setPageLoading(true);

        axios.all([
            dispatch(getDronesIndividual(webappurlForms, accessToken, droneTypes)),
            dispatch(getDroneRateCards(webappurlForms, accessToken, 'DRONE_R_COM')),
            dispatch(getDroneCrmReferenceData(webappurlForms, accessToken, ['Drone Weight Class 2021'], ['DRONE_WEIGHT_CLASS']))
        ])
            .then(axios.spread((dronesres, rcres, crmReferenceDatares) => {
                if (dronesres.type === FETCH_DRONESINDIVIDUAL_SUCCESS
                    && rcres.type === FETCH_RATECARDS_SUCCESS
                    && crmReferenceDatares.type === FETCH_CRMREFERENCEDATA_SUCCESS
                ) {
                    setPageLoaded(true);
                    setPageLoading(false);
                }
                else {
                    setPageLoading(false);
                    setPageLoaded(true);

                    let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                    let details = "Details: DRI.1";
                    dispatch(addPageAlert({ level: "error", title: msg, message: details }));
                }
            }))
            .catch(function () {
                setPageLoading(false);
                setPageLoaded(true);

                let msg = "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk.";
                let details = "Details: DRI.2";
                dispatch(addPageAlert({ level: "error", title: msg, message: details }));
            });
}

    useEffect(() => {
        if (!pageLoaded) return

        if (dronesIndividual.items.value && ratecards.value) {
            let drones = [];
            let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
            let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');
            let msg = '';
            let msglevel = '';

            for (let i = 0; i < dronesIndividual.items.value.length; i++) {
                msg = '';
                msglevel = '';
                if (moment(dronesIndividual.items.value[i]["casa_validuntil"], "YYYY-MM-DD") > expiredRPA && moment(dronesIndividual.items.value[i]["casa_validuntil"], "YYYY-MM-DD") <= expiringRPA) {
                    let droneInd = dronesIndividual.items.value[i];
                    let type = droneInd["reftype.casa_name"];
                    let modelname = droneInd["drone.casa_model"];
                    let manufacturername = droneInd["drone.casa_manufacturer"];
                    let isRegisteredOverseas = droneInd["drone.casa_isregisteredoverseas"] === 1 ? true : false;

                    if (!manufacturername) {
                        manufacturername = droneInd["manufacturer.casa_name"];
                    }
                    if (!modelname) {
                        modelname = droneInd["model.casa_name"];
                    }
                    if (manufacturername === "Home built") {
                        modelname = droneInd.category;
                    }

                    let drone = {};
                    drone.droneRegistrationId = droneInd["casa_droneregistrationid"];
                    drone.droneid = droneInd["drone.casa_droneid"];
                    drone.name = modelname ? `${manufacturername} ${modelname}` : `${manufacturername} ${droneInd["category.casa_name"]}`;
                    drone.manufacturer = manufacturername;
                    drone.model = modelname;
                    drone.serialNumber = droneInd["drone.casa_serialnumber"];
                    drone.validuntil = moment(droneInd["casa_validuntil"], "YYYY-MM-DD").format("DD MMM YYYY");
                    drone.regtype = type;
                    drone.isRegisteredOverseas = isRegisteredOverseas
                    drone.manufacturedWeight = droneInd["model.casa_droneweight"];
                    drone.suggestedWeightClassValue = droneInd["droneWeightClass"];
                    drone.suggestedWeightClassCode = droneInd["droneWeightClassCode"];
                    drone.category = droneInd["category.casa_name"]
                    drone.weightClassList = drone.suggestedWeightClassCode ? getWeightClassList(drone.suggestedWeightClassCode, weightList) : weightList
                    drone.selectedWeightClassValue = drone.droneRegistrationId == droneRegId ? selectedWeightClassValue : ''
                    drone.selectedWeightClassCode = drone.droneRegistrationId == droneRegId ? selectedWeightClassCode : ''

                    if (drone.category === 'Airship') {
                        drone.selectedWeightClassValue = maxWeightClassValue
                        drone.selectedWeightClassCode = maxWeightClassCode
                    }

                    drone.fee = getFeeCost(drone.selectedWeightClassCode, drone.suggestedWeightClassCode, drone.isRegisteredOverseas, ratecards.value)
                    drone.feeDisplay = `$${drone.fee.toFixed(2)}`

                    if (drone.category === 'Airship' || drone.suggestedWeightClassCode === maxWeightClassCode) {
                        drone.editWeight = [
                            { value: maxWeightClassCode, text: maxWeightClassValue }
                        ]
                        drone["weightClassList"] = []
                    } else {
                        drone.editWeight = [
                            { value: "", text: "-- Only select if assigned weight class is incorrect --" }
                        ]
                        for (let j = 0; j < drone["weightClassList"].length; j++) {
                            let option = {
                                value: drone["weightClassList"][j]['casa_code'],
                                text: drone["weightClassList"][j]['casa_name']
                            }
                            drone.editWeight.push(option)
                        }
                    }

                    if (moment(droneInd["casa_validuntil"], "YYYY-MM-DD") < moment() && moment(droneInd["casa_validuntil"], "YYYY-MM-DD") > expiredRPA) {
                        // expired
                        msg = 'Expired';
                        msglevel = 'error';

                        drone.renewedValiduntil = moment().add(1, 'year').format("DD MMM YYYY");
                    }
                    if (moment(droneInd["casa_validuntil"], "YYYY-MM-DD") > moment() && moment(droneInd["casa_validuntil"], "YYYY-MM-DD") <= expiringRPA) {
                        // expiring
                        msg = 'Expiring soon';
                        msglevel = 'warning';

                        drone.renewedValiduntil = moment(droneInd["casa_validuntil"], "YYYY-MM-DD").add(1, 'year').format("DD MMM YYYY");
                    }
                    drone.msg = msg;
                    drone.msglevel = msglevel;

                    //if called from singlerpa use passed droneid else use all
                    if (drone.droneRegistrationId == droneRegId || !droneRegId || renewAll) {
                        drones.push(drone);
                    }
                }
            }
            setDrones(drones)
        }
    }, [pageLoaded, dronesIndividual.items.value, ratecards.value, weightList])

    useEffect(() => {
        calTotalAmount(drones)
    }, [drones])

    useEffect(() => {

        const renewDronesSubmission = () => {
            setApplicationSubmitting(true)
            const webappurlForms = B2CSettings.items.webappurlFormsApi

            let payload = drones.map(drone => ({
                newExpiryDate: moment(drone.renewedValiduntil, "DD MMM YYYY").format(),
                serviceCatalogueCode: 'DRONE_R_RENEWAL',
                droneRegistrationId: drone.droneRegistrationId,
                manufacturer: drone.manufacturer,
                model: drone.model,
                serialNumber: drone.serialNumber,
                suggestedWeightClassValue: drone.suggestedWeightClassValue,
                suggestedWeightClassCode: drone.suggestedWeightClassCode,
                weightClass: drone.selectedWeightClassValue != '' ? drone.selectedWeightClassValue : drone.suggestedWeightClassValue,
                weightClassCode: drone.selectedWeightClassCode != '' ? drone.selectedWeightClassCode : drone.suggestedWeightClassCode,
                selectedWeightClassValue: drone.selectedWeightClassValue != '' ? drone.selectedWeightClassValue : drone.suggestedWeightClassValue,
                selectedWeightClassCode: drone.selectedWeightClassCode != '' ? drone.selectedWeightClassCode : drone.suggestedWeightClassCode,
                isRegisteredOverseas: drone.isRegisteredOverseas,
                fee: drone.fee,
                feeDisplay: drone.feeDisplay,
                droneid: drone.droneid,
                name: drone.name,
                validuntil: drone.validuntil,
                renewedValiduntil: drone.renewedValiduntil,
                regtype: drone.regtype,
                manufacturedWeight: drone.manufacturedWeight,
                category: drone.category,
                weightClassList: drone.weightClassList,
                editWeight: drone.editWeight,
                msg: drone.msg,
                msglevel: drone.msglevel
            }))

            dispatch(
                dronesRenewalSubmission(webappurlForms, B2CSettings.items.accesstokenForms, formProperties, formData, payload, totalAmount)
            )
                .then(response => {
                    if (response.type === SUBMISSION_SUCCESS) {
                        setApplicationSubmitting(false)

                        if (response.payload.paymentToken === null) {
                            setPageLoaded(true);
                            setPageLoading(false);
                            setPaymentSucceeded(true);

                            dispatch(addPageAlert({
                                level: 'success',
                                title: 'Registration renewal successful'
                            }));

                        } else {
                            window.location.href = B2CSettings.items.WestpacQuickWebURL + response.payload.paymentToken;
                        }

                    } else {
                        setApplicationSubmitting(false);

                        dispatch(addPageAlert({
                            level: "error",
                            title: "Unable to complete application online",
                            message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                        }));
                    }
                })
        }

        if (formProperties.submitForm && drones !== null) {
            renewDronesSubmission();
        }
    }, [drones, formProperties.submitForm]);

    const getWeightClassList = (weightClassCode, weightClassList) => {
        let refWeightClassIndex = -1
        let slicedWeightList = weightClassList
        weightClassList.map((item, index) => {
            if (item.casa_code === weightClassCode && item.casa_code !== maxWeightClassCode) {
                refWeightClassIndex = index
            }
        })

        if (refWeightClassIndex >= 0) {
            slicedWeightList = weightClassList.slice(refWeightClassIndex + 1)
        }

        return slicedWeightList
    }

    const getFeeCost = (selectedWeightClassCode, suggestedWeightClassCode, regoOversea, ratecards) => {
        const weightClassCode = selectedWeightClassCode ? selectedWeightClassCode : suggestedWeightClassCode
        let feeGroup = []
        let cost = 0
        ratecards.map(fee => {
            if (fee.droneweightclass_code === weightClassCode) {
                return feeGroup.push(fee)
            }
        });
        feeGroup.map(fee => {
            if (regoOversea && fee.casa_feecode.substring(0, 2) === 'LF') {
                return cost = fee.casa_rate
            } else if (!regoOversea && fee.casa_feecode.substring(0, 2) === 'LC') {
                return cost = fee.casa_rate
            }
        });
        return cost;
    }

    const toggleModal = () => {
        setModalActive(!modalActive);
    }

    const openRemoveDronemodal = (d) => {
        setRemoveDroneId(d["droneRegistrationId"]);
        setRemoveDroneName(d["name"]);
        setRemoveDroneSerial(d["serialNumber"]);

        return toggleModal();
    }

    const removeDrone = () => {
        drones.map((drone, index) => {
            if (drone.droneRegistrationId === removeDroneId) {
                drones.splice(index, 1);
            }
        });
        calTotalAmount(drones);
        setDroneRemoved(true);
        return toggleModal();
    }

    const droneRemovedMsg = () => {
        if (droneRemoved) {
            return (
                <AUpageAlert as="info">
                    <h3>Drone removed from registration renewal</h3>
                    <p>
                        Your {removeDroneName} (Serial no: {removeDroneSerial}) has been removed from your registration renewal. You can still renew it later from your&nbsp;
                        <Link to={'/indmanagerpa?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))}>manage registered drones</Link> page.<br />
                    </p>
                </AUpageAlert>
            );
        }
        else {
            return null;
        }
    }

    const manageComm = (index) => {
        let rec = {
            'droneRegistrationId': index["droneRegistrationId"],
            'droneid': index["droneid"],
            'name': index["name"],
            'manufacturer': index["manufacturer"],
            'model': index["model"],
            'serialNumber': index["serialNumber"],
            'weightClass': index["selectedWeightClassValue"],
            'expirydate': moment(index.validuntil, "DD MMM YYYY").format('DD MMM YYYY'),
            'regtype': index["regtype"],
            'isRegisteredOverseas': index["isRegisteredOverseas"],
            'category': index["category"],
            'suggestedWeightClassValue': index["suggestedWeightClassValue"],
            'suggestedWeightClassCode': index["suggestedWeightClassCode"],
            'manufacturedWeight': index["manufacturedWeight"],
            'weightClassList': index["weightClassList"],
            'fromRenewalTable': true
        };
        history.push("/singlerpa?standalone=" + standalone + "&rpa=" + encodeURIComponent(btoa(JSON.stringify(rec))) + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams))));
    };

    const calTotalAmount = (drones) => {
        let total = 0;
        drones.map(drone => {
            total += drone.fee;
        });
        setTotalAmount(total.toFixed(2));
    }

    const isRemoveVisible = () => {
        return drones.length > 1;
    }

    const onChangeWeight = (index, row) => {
        if (index == 0) return;
        let changedDrone = drones.find(x => x.droneRegistrationId === row.droneRegistrationId)
        if (changedDrone) {
            changedDrone.selectedWeightClassCode = changedDrone.editWeight[index].value
            changedDrone.selectedWeightClassValue = changedDrone.editWeight[index].text
            changedDrone.fee = changedDrone.selectedWeightClassCode ? getFeeCost(changedDrone.selectedWeightClassCode, changedDrone.suggestedWeightClassCode, changedDrone.isRegisteredOverseas, ratecards.value) : 0
            changedDrone.feeDisplay = `$${changedDrone.fee.toFixed(2)}`

            let changedDrones = [...drones]
            setDrones(changedDrones);
        }
    }

    const droneCols = [
        {
            "label": "Drone",
            "property": "name",
            "visible": true,
            "type": "string",
            "commandLink": manageComm,
            "width": "30%"
        },
        {
            "label": "Serial number / registration mark",
            "property": "serialNumber",
            "visible": true,
            "type": "string",
            "masterStatus": "Active",
            "status": "Active",
            "width": "30%"
        },
        {
            "label": "Assigned weight class",
            "property": "suggestedWeightClassValue",
            "visible": true,
            "type": "string",
            "width": "30%"
        },
        {
            "label": "Selected weight class",
            "property": "editWeight", //an array (strings/objects)
            "visible": true,
            "type": "dropdown",
            "onChange": onChangeWeight,
            "default": "selectedWeightClassCode",
            "width": "20%"
        },
        {
            "label": "Expiry date",
            "property": "validuntil",
            "visible": true,
            "hasMsg": "msg",
            "hasMsglevel": "msglevel",
            "type": "date",
            "width": "20%"
        },
        {
            "label": "Fee",
            "property": "feeDisplay",
            "visible": true,
            "type": "int",
            "width": "20%"
        }
    ]

    const removeCol = [{
        "label": null,
        "property": null,
        "visible": true,
        "command": "Remove",
        "commandLink": openRemoveDronemodal,
        "commandVisible": isRemoveVisible,
        "type": null
    }]

    const otherDronesMsg = () => {
        if (droneRegId !== "") {

            let expiringRPA = moment().startOf('day').add(daysRPAexpiring, 'days').subtract(1, 'days');
            let expiredRPA = moment().endOf('day').subtract(daysRPAexpired, 'days');

            let found = dronesIndividual.items.value.findIndex(index => index.casa_droneregistrationid !== droneRegId &&
                ((moment(index["casa_validuntil"], "YYYY-MM-DD") < moment() && moment(index["casa_validuntil"], "YYYY-MM-DD") > expiredRPA) ||
                (moment(index["casa_validuntil"], "YYYY-MM-DD") > moment() && moment(index["casa_validuntil"], "YYYY-MM-DD") <= expiringRPA)));

            if (found >= 0) {
                return (
                    <AUpageAlert as="info">
                        <h3>You have more drones that are expiring soon</h3>
                        <p>
                            You can renew multiple drones at once on the&nbsp;
                            <a href={'/forms/dronesrenewind?standalone=' + standalone + "&params=" + encodeURIComponent(btoa(JSON.stringify(jparams)))}>main renew drone registration page.<br /></a>
                        </p>
                    </AUpageAlert>
                );
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    const showTable = () => {
        return (
            <SortedTable
                data={drones}
                cols={drones.length > 1 ? droneCols.concat(removeCol) : droneCols}
                caption="Commercial drones and RPA"
                sortby="name"
                order="asc"
                footer={footer} />
        )
    }

    
    const validatePayment = () => {
        const webappurlForms = B2CSettings.items.webappurlFormsApi;

        dispatch(
            validateHmac(
                webappurlForms,
                B2CSettings.items.accesstokenForms,
                returnParameters
            )
        )
            .then(response => {
                if (response.type === VALIDATE_HMAC_SUCCESS) {
                    setPageLoaded(true);
                    setPageLoading(false);
                    setPaymentSucceeded(true);

                    dispatch(addPageAlert({
                        level: 'success',
                        title: 'Registration renewal successful'
                    }));
                } else {
                    setPageLoaded(true);
                    setPageLoading(false);
                    setPaymentSucceeded(false);

                    dispatch(addPageAlert({
                        level: "error",
                        title: "Unable to complete application online",
                        message: 'Unfortunately this application cannot be completed online. Please contact us for further information.'
                    }));
                }
            })
    }

    const footer = () => {
        return (
            <tr className="au-table__header">
                <td scope="col" className="au-table__header" colSpan={3}></td>
                <td scope="col" className="au-table__header au-table__header--numeric"><strong>Total</strong></td>
                <td scope="col" className="au-table__header au-table__header" colSpan={2}><strong>{`$${totalAmount}`}</strong></td>
            </tr>
        );
    }

    const successRenewPage = () => {
        return (
            <SuccessScreen>
                <Fragment>
                    <p>Thank you {user.items.value[0].fullname},</p>
                    <p>Your drone(s) (RPA) have had their registration renewed by CASA.
                        This may take a few minutes to process. Once complete, a confirmation email will be sent to your email address <strong>{user.items.value[0].emailaddress1}</strong>.
                        You will then also be able to access your updated certificate of registration under the drone registration section in myCASA.</p>
                    <div dangerouslySetInnerHTML={{ __html: snippet }}></div>
                </Fragment>
            </SuccessScreen>
        )
    }

    const validateTable = () => {
        for (let i = 0; i < drones.length; i++) {
            if (!drones[i]["suggestedWeightClassCode"] && drones[i]["selectedWeightClassCode"] === '') {
                setTableError('Please select an option. <br/> A valid Drone weight classification must be selected if there is no Suggested weight class for the drone')
                return 'Select a weightclass'
            }
        }
        setTableError('')
        return ''
    }

    const createTableErrorMessage = () => {
        if (tableError !== '') {
            return (<span className='au-error-text' dangerouslySetInnerHTML={{ __html: tableError }}></span>)
        }
    }

    const loadQuestionsStep1 = (questions) => {
        if (questions.declaration) {
            // force not checked so user has to click again to submit
            questions.declaration.answer.checked = false
            questions.declaration.answer.value = ''
            questions.declaration.answer.checkboxValues = []
        }
    }

    const saveDraftRenew = () => {
        formData.drones = drones;

        const webappurlForms = B2CSettings.items.webappurlFormsApi;
        setApplicationSaving(true); 

        dispatch(saveDraft(webappurlForms, B2CSettings.items.accesstokenForms, formProperties, formData))
            .then(response => {
                if (response.type === SAVE_DRAFT_SUCCESS) {
                    setApplicationSaving(false);
                    window.location.href = formProperties.draftReturnUrl + "&saveSuccess=1";
                } else {
                    setApplicationSaving(false);
                    dispatch(addPageAlert({
                        level: "error",
                        title: "Something has gone wrong",
                        message: "We're sorry. Something has gone wrong. Try again. If the error persists contact the CASA Help Desk."
                    }));
                }
            });
    }

    const loadDraftRenew = (draftFormData) => {       
        setDrones(draftFormData.drones)
        calTotalAmount(draftFormData.drones)

        let questions = draftFormData.steps[0].questions

        loadQuestionsStep1(questions) 

        axios.all([
            dispatch(addDraftFormDataPromise(draftFormData))
        ])
            .then(() => {
                axios.all([
                    dispatch(addStepDataPromise("renewDrone", "Drone summary", questions))
                ])
                    .then(() => {
                        return;
                    })
            })
    }

    if (pageLoading || applicationSaving) {
        return (
            <Fragment>
                <MetaTags>
                    <title>Renew drone registration (Individual)</title>
                </MetaTags>

                <Container show={true}>

                    <CASASpinner message="Working. Please wait....." />

                </Container>

            </Fragment>
        )
    }
    else {
        if (!pageLoaded) {
            return null;
        }

        if (paymentSucceeded) {
            return successRenewPage();
        }

        return (
            <Fragment>
                {droneRemovedMsg()}

                {otherDronesMsg()}

                {applicationSubmitting ? <CASASpinner message='Submitting form' /> : null}
                <CasaModal
                    heading="Remove drone"
                    toggle={toggleModal}
                    active={modalActive}
                    action={removeDrone}>
                    <Fragment>
                        <p>Are you sure you want to remove your drone?</p>
                        <br />
                        <strong>Drone</strong><br />{removeDroneName}<br /><br />
                        <strong>Serial number / registration mark</strong><br />{removeDroneSerial}
                        <p>Your drone will not be renewed.</p>
                    </Fragment>
                </CasaModal>
                <Application
                    formInformation={{
                        id: "renewDroneForm",
                        name: "Renew drone registration",
                        title: "Renew drone registration",
                        rootFormCode: "DRONE_R_RENEWAL",
                        formCode: "DRONE_R_RENEWAL",
                        formDataType: "genericFormData",
                        version: "01"
                    }}
                    formActions={{
                        loadDraft: loadDraftRenew
                    }}
                    enableSaveButton={false}
                    showback={true}
                    breadcrumbs={crumbs}>
                    <Fragment>
                        <AUcallout
                            title=""
                            srOnlyTitle
                            //Inline style to fit the wireframe
                            style={{ maxWidth: `100%` }}>
                            <h4>Your drone registration will not be renewed until you have completed the declaration below and submitted this form.</h4>
                        </AUcallout>
                        <br />

                        <AUcallout
                            title="New weight class requirements"                           
                            //Inline style to fit the wireframe
                            style={{ maxWidth: `100%` }}>
                            <p>From July 27th 2021 CASA requires the weight class for all registered drones. Please ensure all weight classes against your registered drones are correct.</p>
                        </AUcallout>
                        <br />
                        <Step
                            id="renewDrone"
                            stepTitle=""
                            initialStep
                            isLastStep
                            saveDraft={saveDraftRenew}
                            submitText={totalAmount == 0.00 ? "Submit" : "Proceed to payment"}
                            showback={false} >
                            <Question
                                id="table"
                                stepid="renewDrone"
                                key="table"
                                name="table"
                                label='table'
                                mandatory={false}
                                validate={validateTable}
                                colspan={12}>
                                <Fragment>
                                    {showTable()}

                                    {createTableErrorMessage()}
                                </Fragment>
                            </Question>
                            <Question
                                id="declaration"
                                stepid="renewDrone"
                                key="declaration"
                                type="declaration"
                                name="declaration"
                                label="I agree to and understand the above conditions."
                                value="declaration">
                                <Fragment>
                                    <p>I hereby declare that the particulars set out in this application are true in every respect.
                                        I acknowledge that to knowingly make a false or misleading statement in this application is an offence against the Criminal Code Act 1995 (Cth).</p>
                                    <p>I am aware and accept the risk that information sent electronically may be intercepted and read during transmission, not delivered or modified.</p>
                                    <p>I have read <a href="https://www.casa.gov.au/node/37026">
                                        CASA’s policy on the collection and release of information</a> and
                                    I authorise CASA to release information contained on this form in accordance with that policy.</p>
                                </Fragment>
                            </Question>
                        </Step>
                        <AUformGroup>
                            <AUDirectionLink link='/forms/dashind' text="Return to myCASA" direction="left" style={{ marginTop: `50px` }} />
                        </AUformGroup>
                    </Fragment>
                </Application>
            </Fragment>
        )
    }

}

